// extracted by mini-css-extract-plugin
module.exports = {"cursorPointer":"navbar_cursorPointer___zYvt","burgerMenu":"navbar_burgerMenu__1W2rF"};